import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TCCPLoggerService } from './tccp-logger.service';
import { TCCPHttpResponseHandler } from './tccp-http-response-handler.service';
import { TCCPHttpService } from './tccp-http.service';
import { TCCPHttpErrorHandler } from './tccp-http-error-handler.service';

@NgModule({
    imports: [CommonModule],
    providers: [TCCPHttpResponseHandler, TCCPHttpService, TCCPLoggerService, TCCPHttpErrorHandler]
})
export class TCCPHttpServiceModule { }


